import { Component, Input, HostBinding } from '@angular/core';

/**
 *
 * Flip card example:
 * @stacked-example(Showcase, flip-card/flip-card-showcase.component)
 *
 * As a content Flip card accepts two instances of `el-card` - for front and back sides.
 *
 * Basic flip card configuration:
 *
 * ```html
 * <el-flip-card>
 *   <el-card-front>
 *     <el-card>
 *       <el-card-body>
 *         Front
 *       </el-card-body>
 *     </el-card>
 *   </el-card-front>
 *   <el-card-back>
 *     <el-card>
 *       <el-card-body>
 *         Back
 *       </el-card-body>
 *     </el-card>
 *   </el-card-back>
 * </el-flip-card>
 * ```
 *
 * ### Installation
 *
 * Import `ElCardModule` to your feature module.
 * ```ts
 * @NgModule({
 *   imports: [
 *     // ...
 *     ElCardModule,
 *   ],
 * })
 * export class PageModule { }
 * ```
 * ### Usage
 *
 * Flip Card with header and footer:
 * @stacked-example(With Header & Footer, flip-card/flip-card-full.component.ts)
 *
 * Colored flip-cards could be simply configured by providing a `status` property:
 * @stacked-example(Colored Card, flip-card/flip-card-colors.component)
 *
 * It is also possible to assign an `accent` property for a slight card highlight
 * as well as combine it with `status`:
 * @stacked-example(Accent Card, flip-card/flip-card-accents.component)
 *
 * @additional-example(Multiple Sizes, flip-card/flip-card-sizes.component)
 *
 */
@Component({
  selector: 'el-flip-card',
  styleUrls: ['./flip-card.component.css'],
  template: `
    <div class="flipcard-body">
      <div class="front-container">
        <ng-content select="el-card-front"></ng-content>
        <a *ngIf="showToggleButton" class="flip-button" (click)="toggle()">
          <el-icon icon="chevron-left-outline" pack="endlessjs-essentials" aria-hidden="true"></el-icon>
        </a>
      </div>
      <div class="back-container">
        <ng-content select="el-card-back"></ng-content>
        <a *ngIf="showToggleButton" class="flip-button" (click)="toggle()">
          <el-icon icon="chevron-left-outline" pack="endlessjs-essentials" aria-hidden="true"></el-icon>
        </a>
      </div>
    </div>
  `,
})
export class ElFlipCardComponent {
  /**
   * Flip state
   * @type boolean
   */
  @Input()
  @HostBinding('class.flipped')
  flipped: boolean = false;

  /**
   * Show/hide toggle button to be able to control toggle from your code
   * @type {boolean}
   */
  @Input() showToggleButton = true;

  toggle() {
    this.flipped = !this.flipped;
  }
}
